import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/system';
import MobileTabView from 'src/components/StageV2/MobileTabView';
import CurrentVehicleTracking from 'src/components/StageV2/CurrentVehicleTracking';
import IncomingVehicleTracking from 'src/components/StageV2/IncomingVehicleTracking';

export default function StageDashboardMainContentV2({
  showRightSidebar,
  toggleRightSidebarTable,
}) {
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const { stationData } = vehicleTrackingDataReducer;
  const isMobile = useMediaQuery('(max-width:600px)');
  const screenXl = useMediaQuery('(min-width:2400px)');
  const screenSize = screenXl ? 4 : 6;
  const colSize = showRightSidebar ? 6 : screenSize;

  const tabComponents = [
    {
      title: 'Incoming',
      count: stationData?.incomingVehicleTracking?.count,
      borderColor: 'border-bottom-yellow',
      textColor: 'text-yellow',
      component: <IncomingVehicleTracking colSize={colSize} />,
    },
    {
      title: 'Current',
      count: stationData?.currentVehicleTracking?.count,
      borderColor: 'border-bottom-green',
      textColor: 'text-green',
      component: <CurrentVehicleTracking colSize={colSize} />,
    },
  ];

  return (
    <div>
      {!isMobile && (
        <Row className="g-3 p-2">
          {stationData?.incomingVehicleTracking && (
            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
              <div className="vehicle-tracking-card-yellow">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-lg text-semi-bold">Incoming</span>
                  <span className="text-xl">
                    {stationData?.incomingVehicleTracking?.count}
                  </span>
                </div>
              </div>
            </Col>
          )}
          <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
            <Row className="g-3">
              <Col xxl={10} xl={10} lg={10} md={9} sm={9} xs={9}>
                <div className="vehicle-tracking-card-green">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-lg text-semi-bold">Current</span>
                    <span className="text-xl">
                      {stationData?.currentVehicleTracking?.count}
                    </span>
                  </div>
                </div>
              </Col>
              <Col xxl={2} xl={2} lg={2} md={3} sm={3} xs={3}>
                {!showRightSidebar && (
                  <button
                    className={`header-button theme-background-${themeColor}`}
                    onClick={() => toggleRightSidebarTable()}
                  >
                    <span className="text-white">Scan</span>
                  </button>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {isMobile ? (
        <MobileTabView tabComponents={tabComponents} />
      ) : (
        <div
          className={`stage-dashboard-data-container left-padding right-padding theme-scrollable-container-${themeColor}`}
        >
          {/* Left Column (Incoming) */}
          <Row className="rg-10">
            <IncomingVehicleTracking colSize={colSize} />
            {/* Right Column (Current) */}
            <CurrentVehicleTracking colSize={colSize} />
          </Row>
        </div>
      )}
    </div>
  );
}
